<template>
  <div class="call-action flex cursor-pointer items-center justify-center rounded-full bg-black/20 hover:bg-black/30">
    <slot />
  </div>
</template>
